// extracted by mini-css-extract-plugin
export default {"icon":"Application_icon__D+2c-"};